	<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">获取人员/人员组的识别记录</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			person_record接口提供了获取人员/人员组识别记录的功能。
		</p>
		<h3 class="doc_main_h3">调用URL</h3>
		<pre class="doc_main_pre"><code class="doc_main_code"><a href="https://skfrm.cn/APIV2/person_record">https://skfrm.cn/APIV2/person_record</a></code></pre>		
        <h3 class="doc_main_h3">请求参数</h3>
		<frm-Request-parameters :propsTableData="frmRequestParams"></frm-Request-parameters>
        <h3 class="doc_main_h3">返回值说明</h3>
		<frm-Return-Value-New :propsTableData='frmReturnValueNew'></frm-Return-Value-New>
		<!-- <h3 class="doc_main_h3">通用错误码</h3>
		<frm-Error-Code :propsTableData='frmErrorCode'></frm-Error-Code> -->
		<h3 class="doc_main_h3">返回值示例</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">成功：
	{
		"error_code":"0",
		"error_msg":"success",
		"data":
		[
			{
				"date":"2018-11-22 15:14",
				"terminal_name":"魅族",
				"person_name":"蔡志伟new",
				"image_url":"http://dev.skfrm.sk-ai.com/Uploads/image/2018-11-22/original1542870840744.jpg",
				"person_id":"135331",
				"record_image_url":"http://dev.skfrm.sk-ai.com/Uploads/image/2018-07-25/head_1532511441707.jpg",
				"group_names":["0110H5注册测试"]
			}
		],
		"record_number":"192"
	}
失败：
	{
		"error_code":"4",
		"error_msg":"服务器内部错误"
	}
</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	import FrmRequestParamsTable from'../../../../components/frmRequestParamsTable';
	import FrmReturnValueTableNew from '../../../../components/frmReturnValueTableNew';
	import FrmErrorCodeTable from '../../../../components/frmErrorCodeTable';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
			'frm-Request-parameters':FrmRequestParamsTable,
			'frm-Return-Value-New':FrmReturnValueTableNew,
			'frm-Error-Code':FrmErrorCodeTable,
		},
		data(){
			return{
				isPathData:['FRM API-v2','统计信息','获取人员/人员组的识别记录'],
				frmRequestParams:[
					{"require":"是","name":"account_id","type":"int","msg":"当前账号id"},
					{"require":"是","name":"token","type":"string","msg":"当前账号登录后返回的token"},
					{"require":"是","name":"project_id","type":"int","msg":"项目id"},
					{"require":"是","name":"type","type":"string","msg":"人员组按日期获取 pgroup人员按日期获取 person"},
					{"require":"是","name":"id","type":"int","msg":"要获取的人员id或人员组id"},
					{"require":"是","name":"date","type":"string","msg":"指定日期区间的毫秒时间戳  例 1539100800000，1539100800000，获取指定时间段的识别记录"},
					{"require":"否","name":"page","type":"int","msg":"识别记录列表页索引，索引值从1开始"},
					{"require":"否","name":"pagesize","type":"int","msg":"识别记录列表页每页显示记录条数（默认为10，最大为10000）"},
				],			
				frmReturnValueNew:[
					{
						"Parameter":"error_code",
						"name":"string",
						"msg":"0 成功  1 失败",
						"rowspan":1,
						"colspan":1,
					},
					{
						"Parameter":"error_msg",
						"name":"string",
						"msg":"成功返回 success  失败返回 fail",
						"rowspan":1,
						"colspan":1,
					},
					{"Parameter":"record_number","name":"string","msg":"识别记录总条数","rowspan":1,"colspan":1},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"识别记录信息数组",
						"rowspan":8,
						"colspan":1,
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"person_id    string    人员id",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"person_name    string  识别人员注册的头像",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"image_url    string   识别人员注册的头像",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"record_image_url    string    该人员被终端抓拍的大头照",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"terminal_name    string    识别该人员终端的名字",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"date    string    被识别的时间",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"group_names    array    人员组名称",
					},
				],
				frmErrorCode:[
					{"Statuscode":"1","errormessage":"fail","msg":"服务器繁忙"},
					{"Statuscode":"9001","errormessage":"token无效","msg":"token过期"},
				],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/FRMAPIVTOW/statisticalinformation/identificationrecords.vue